// Peso da venda por peso como a loja vê (T-0056, 04/11/2026: «ml» ao lado de kg e g). O canônico é SEMPRE kg, e 1 ml =
// 1 g = 0,001 kg: a unidade do produto (products.weight_unit) e a do item (order_items.weight_unit; nula = kg) só dizem
// como mostrar.
export type UnidadeDePeso = "kg" | "g" | "ml";

export function unidadeDePeso(u: string | null | undefined): UnidadeDePeso {
  return u === "g" || u === "ml" ? u : "kg";
}

/** «1,5 kg», «250 g», «5 ml». */
export function formatarPeso(kg: number, unidade?: string | null): string {
  const u = unidadeDePeso(unidade);
  if (u === "kg") return `${(Math.round(kg * 1000) / 1000).toLocaleString("pt-BR", { maximumFractionDigits: 3 })} kg`;
  return `${Math.round(kg * 1000).toLocaleString("pt-BR")} ${u}`;
}

/** O preço de referência do produto (o preço gravado é o do kg/litro): por kg em kg; por 100 g ou 100 ml nas outras. */
export function precoDeReferencia(precoKg: number, unidade?: string | null): { valor: number; rotulo: string } {
  const u = unidadeDePeso(unidade);
  if (u === "kg") return { valor: precoKg, rotulo: "/kg" };
  return { valor: Math.round(precoKg * 10) / 100, rotulo: `/100 ${u}` };
}
